"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _productLine = _interopRequireDefault(require("./product-line"));
var _planLine = _interopRequireDefault(require("./plan-line"));
var _subTitleLine = _interopRequireDefault(require("./sub-title-line"));
var _util = require("../../../util");
var BLOCK_CLASS = 'pf-offer-title';
var OfferTitle = function OfferTitle(_ref) {
  var className = _ref.className,
    amount = _ref.amount,
    title = _ref.title,
    bank = _ref.bank,
    plan = _ref.plan,
    subTitle = _ref.subTitle,
    counterMessage = _ref.counterMessage,
    expiryDate = _ref.expiryDate,
    noOfDaysToExpiry = _ref.noOfDaysToExpiry;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _util.addClassNames)(className, BLOCK_CLASS)
  }, /*#__PURE__*/_react.default.createElement(_productLine.default, {
    amount: amount,
    title: title,
    bank: bank,
    counterMessage: counterMessage,
    expiryDate: expiryDate,
    noOfDaysToExpiry: noOfDaysToExpiry
  }), /*#__PURE__*/_react.default.createElement(_planLine.default, {
    firstLineText: plan.title,
    secondLineText: plan.subTitle,
    superScript: plan.superScript
  }), /*#__PURE__*/_react.default.createElement(_subTitleLine.default, {
    text: subTitle
  }));
};
OfferTitle.propTypes = {
  amount: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired,
  bank: _propTypes.default.string.isRequired,
  plan: _propTypes.default.shape({
    title: _propTypes.default.string,
    subTitle: _propTypes.default.string,
    superScript: _propTypes.default.string
  }).isRequired,
  subTitle: _propTypes.default.string.isRequired,
  counterMessage: _propTypes.default.string,
  className: _propTypes.default.string,
  expiryDate: _propTypes.default.string.isRequired,
  noOfDaysToExpiry: _propTypes.default.number.isRequired
};
OfferTitle.defaultProps = {
  counterMessage: '',
  className: ''
};
var _default = exports.default = OfferTitle;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-confirm-apply/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');